import { render, staticRenderFns } from "./LoginFollow.vue?vue&type=template&id=29c48c1c&"
import script from "./LoginFollow.vue?vue&type=script&lang=js&"
export * from "./LoginFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports